module.exports = __webpack_public_path__ + "img/ubp.42e3df4f.png";